import { render, staticRenderFns } from "./identity-verify.vue?vue&type=template&id=7a952df6&scoped=true"
import script from "./identity-verify.vue?vue&type=script&lang=ts"
export * from "./identity-verify.vue?vue&type=script&lang=ts"
import style0 from "./identity-verify.vue?vue&type=style&index=0&id=7a952df6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a952df6",
  null
  
)

export default component.exports